import { defineStore } from 'pinia';



export const useWuerfeStore = defineStore("wurf", {
    state: () => ({
        crew: {
            male: [],
            female: [
                {
                    id: "siri",
                    name: "Nova Scotia's Sirona",
                    link: "/crew/siri",
                },
            ],
            neutered: {
                male: [
                    {
                        id: "othello",
                        name: "Othello of Goodclaws",
                        link: "/crew/othello",
                    },
                    {
                        id: "conan",
                        name: "Nova Scotia's Conan",
                        link: "/crew/conan",
                    },
                ],
                female: [
                    {
                        id: "loki",
                        name: "Loki of Goodclaws",
                        link: "/crew/loki",
                    }
                ],
            }
        },
        cats: {
            "bibo":{
                link: "http://www.novascotias-mainecoons.de/crew/kater/bibo/",
                id: "bibo",
                name: "Nova Scotia's Big Boss (Bibo)",
                own: false,
                sire: true,
                dam: false,
                neutered: false,
                genes: {
                    'agouti': [1, 0],
                    'nondilution': [0, 0],
                    'silver': [0, 0],
                    'spotwhite': [0, 0],
                    'mackerel': [0, 0],
                    'white': [0, 0],
                    'red': [1, 1],
                }
            },
            "conan":{
                link: "/crew/conan",
                genteste: [],
                id: "conan",
                name: "Nova Scotia's Conan",
                own: true,
                sire: true,
                dam: false,
                neutered: true,
                genes: {
                    'agouti': [2, 2],
                    'nondilution': [2, 2],
                    'silver': [2, 2],
                    'spotwhite': [2, 2],
                    'mackerel': [2, 2],
                    'white': [2, 2],
                    'red': [2, 2],
                },
                birthday: new Date("2020-11-11T00:00:00.000Z"),
                color: "Creme White Tabby Classic",
                colorcode: "MCO e 09 22",
                healthdata: [],
                pawpedslink: "https://www.pawpeds.com/db/?a=p&ids=3:1410396;2:1448615&g=4&p=mco",
            },
            "othello":{
                link: "/crew/othello",
                genteste: [],
                id: "othello",
                own: true,
                name: "Othello of Goodclaws",
                sire: true,
                dam: false,
                neutered: true,
                genes: {
                    'agouti': [0, 0],
                    'nondilution': [0, 1],
                    'silver': [0, 0],
                    'spotwhite': [0, 0],
                    'mackerel': [0, 0],
                    'white': [0, 0],
                    'red': [0, 0],
                },
                birthday: new Date("2019-12-24T00:00:00.000Z"),
                color: "Black",
                colorcode: "MCO n",
                healthdata: [
                ],
                pawpedslink: "https://pawpeds.com/db/?a=p&ids=3:1447498;2:1448573&g=4&p=mco",
            },
            "loki":{
                link: "/crew/loki",
                genteste: [],
                id: "loki",
                name: "Loki of Goodclaws",
                own: true,
                sire: false,
                dam: true,
                neutered: true,
                genes: {
                    'agouti': [0, 0],
                    'nondilution': [0, 0],
                    'silver': [0, 0],
                    'spotwhite': [1, 0],
                    'mackerel': [2, 2],
                    'white': [0, 0],
                    'red': [0, 0],
                },
                birthday: new Date("2019-12-24T00:00:00.000Z"),
                color: "Blue White",
                colorcode: "MCO a 09",
                healthdata: [
                ],
                pawpedslink: "https://pawpeds.com/db/?a=p&ids=3:1447498;2:1448573&g=4&p=mco",
            },
            "siri":{
                link: "/crew/siri",
                id: "siri",
                name: "Nova Scotia's Sirona",
                own: true,
                sire: false,
                dam: true,
                neutered: false,
                genes: {
                    'agouti': [1, 0],
                    'nondilution': [1, 0],
                    'silver': [1, 0],
                    'spotwhite': [0, 0],
                    'mackerel': [0, 0],
                    'white': [0, 0],
                    'red': [0, 0],
                },
                birthday: new Date("2022-03-25T00:00:00.000Z"),
                color: "Black Silver Tabby Classic",
                colorcode: "MCO ns 22",
                genteste: [
                    ["FIV", "Negativ"],
                    ["FELV", "Negativ"],
                    ["HCM1+3", "N/N"],
                    ["SMA", "N/N"],
                    ["PKD", "N/N"],
                    ["Pk-def", "N/N"],
                    ["GSDIV", "N/N"],
                    ["rdAc-PRA", "N/N"],
                ],
                healthdata: [
                    {
                        'id':'bloodtype',
                        'title':'Blutgruppe',
                        'value':'A',
                    },
                    {
                        'id':'pkd',
                        'title':'PKD (Schall)',
                        'value':'02/2023 Negativ',
                    },
                    {
                        'id':'hcm',
                        'title':'HCM (Schall)',
                        'value':'02/2023 Negativ',
                    },
                    {
                        'id':'pl',
                        'title':'PL',
                        'value':'03/2023 PL = Grad 0',
                    },
                    {
                        'id':'hd',
                        'title':'HD',
                        'value':'03/2023 Ohne Befund',
                    },
                ],
                pawpedslink: "https://www.pawpeds.com/db/?a=p&id=1663596&p=mco",
            },
        },
        wuerfe: [
            {
                id: "wurfA",
                wurfId: "A",
                title: "A-Wurf",
                link: "/wuerfe/A",
                data: {
                    sire: {
                        name: "Nova Scotia's Big Boss (Bibo)",
                    },
                    dam: {
                        name: "Nova Scotia's Sirona",
                    }
                }
            },
        ],
    }),
    getters: {
    },
    actions: {
    }
});
